import { message } from "antd";
import axios from "axios";
import { forEach as _forEach, get, isEmpty } from "lodash";

import { host } from "config";
import { imgDefaultHeaders } from "shared/method";
import { roughLogOut } from "../session";
import { BULK_CREATE, COUNT, CREATE, DELETE, GET_LIST, GET_ONE, UPDATE } from "./requestType";

const getOptionByType = (type, resource, param = {}) => {
  let option = { url: "", method: "" };
  let formData = new FormData();
  switch (type) {
    case GET_LIST:
      option.method = "GET";
      if (resource.slice(-1) === "y") option.url = `${host}/${resource.slice(0, -1)}ies`;
      else option.url = `${host}/${resource}s`;
      break;
    case GET_ONE:
      option.method = "GET";
      option.url = `${host}/${resource}/${param.id}`;
      break;
    case CREATE:
      option.method = "POST";
      option.url = `${host}/${resource}`;
      _forEach(param.body, function (v, k) {
        formData.append(k, v);
      });
      option.data = formData;
      break;
    case BULK_CREATE:
      option.method = "POST";
      option.url = `${host}/${resource}/bulkcreate`;
      _forEach(param.body, function (v, k) {
        if (k === "files" && Array.isArray(v)) {
          v.forEach((file) => formData.append(k, file));
        } else formData.append(k, v);
      });
      option.data = formData;
      break;
    case UPDATE:
      option.method = "PUT";
      option.url = `${host}/${resource}/${param.id}`;
      option.data = param.body;
      break;
    case DELETE:
      option.method = "DELETE";
      option.url = `${host}/${resource}/${param.id}`;
      break;
    case COUNT:
      option.method = "GET";
      option.url = `${host}/${resource}/count`;
      break;
    default:
      return {};
  }
  return option;
};

export const imageProvider = (type, resource, params) => {
  const option = getOptionByType(type, resource, params);
  if (isEmpty(option)) throw Error("no match request type");

  return axios({
    ...option,
    headers: imgDefaultHeaders()
  }).catch((error) => {
    if (!error || error.response.status === 401) {
      roughLogOut();
    }
    if (get(error, "response.data")) {
      message.destroy();
      message.error(get(error, "response.data") || "錯誤");
    }
    return {
      err: true,
      status: get(error, "response.status"),
      message: get(error, "response.data") || error.message
    };
  });
};
